import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform(array: any[] | null, propertyName: string): any[] {
    if (array) {
      if (!Array.isArray(array)) {
        return array;
      }

      return array.sort((a, b) => {
        const aVal = a[propertyName];
        const bVal = b[propertyName];
        if (aVal < bVal) {
          return -1;
        } else if (aVal > bVal) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return [];
  }
}
